export default __webpack_public_path__ + "static/media/speaking.512cabbb.svg";